import { ICON_COLOR, ICON_TYPE } from "components/IconComponent/constants";

const IconCancel = ({type = ICON_TYPE.CB002B, width=14, height=14}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14 14" fill="none">
            <path d="M12.6914 10.5617L9.12958 6.99995L12.6914 3.43818C14.0648 2.06473 11.9348 -0.065261 10.5614 1.30819L6.99959 4.86996L3.43781 1.30819C2.06472 -0.0649085 -0.0652741 2.06508 1.30782 3.43818L4.86959 6.99995L1.30782 10.5617C-0.0656272 11.9352 2.06437 14.0652 3.43781 12.6917L6.99959 9.12994L10.5614 12.6917C11.9346 14.065 14.0646 11.935 12.6914 10.5617Z" fill={ICON_COLOR[type] || type}/>
        </svg>
    )
}

export default IconCancel;